<div class="neq-container neq-aside-container">
  <h1>{{ 'label.common.edition.events' | translate }}</h1>
  <ng-template *ngIf="auditableDto; then updateTemplate else creationTemplate"></ng-template>
  <ng-template #updateTemplate>
      <span>
          {{ 'label.common.edition.saved.date' 
                | translate:{ 
                              date: (auditableDto.modificationDate | localDateFormat ),
                              time: (auditableDto.modificationDate | localTimeFormat ), 
                              user_full_name: auditableDto.modifiedBy 
                            } 
          }}
      </span>
  </ng-template>
  <ng-template #creationTemplate>
      <span>
        {{ 'label.common.edition.events.creation' | translate }}
      </span>
  </ng-template>
</div>
